<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useRoute, RouterView } from "vue-router";
import AppLayout from "./components/AppLayout.vue";
import SyncQueueBootstrap from "./components/SyncQueueBootstrap.vue";
import { useAuthStore } from "./stores/auth";
import { useConfigStore } from "./stores/config";

const route = useRoute();
const auth = useAuthStore();
const config = useConfigStore();

// The Login page renders itself with a bare layout (centered card);
// everything else uses the full header + nav + footer layout.
const useBareLayout = computed<boolean>(() => route.meta.layout === "bare");

onMounted(() => {
  // Hydrate persisted state once when the app boots.
  auth.bootstrap();
  config.bootstrap();
});
</script>

<template>
  <!--
    SyncQueueBootstrap mounts FIRST so the online/offline listeners
    (P.4) are installed before any page renders. Renders nothing.
  -->
  <SyncQueueBootstrap />
  <RouterView v-if="useBareLayout" />
  <AppLayout v-else>
    <RouterView />
  </AppLayout>
</template>